var lib_core = require("lib-core");
var DualRowPackageWithDifferentPadsData = require('./dualRowPackageWithDifferentPadsData.js');

var DfnPackageWithDifferentPadsData = function(position, angle, init) {
    DualRowPackageWithDifferentPadsData.apply(this, arguments);

    //pad width for odd size pad which is different from others
    this.oddPadWidthMax = this.value("oddPadWidthMax", true);
    this.oddPadWidthMin = this.value("oddPadWidthMin", true);

    this.horizontalPinPitch = this.value("horizontalPinPitch",true);

    //component family if any
    this.componentFamily = this.value("componentFamily", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.horizontalPinPitch);
    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
 
};
lib_core.inherit(DfnPackageWithDifferentPadsData, DualRowPackageWithDifferentPadsData);
lib_core.JsonParser.registerClass(DfnPackageWithDifferentPadsData, "DfnPackageWithDifferentPadsData");

DfnPackageWithDifferentPadsData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageWithDifferentPadsData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["oddPadWidth"] = [this.oddPadWidthMin, this.oddPadWidthMax];
    this.validationMap["oddPadWidthMax"] = [this.oddPadWidthMax];
    this.validationMap["horizontalPinPitch"] = [this.horizontalPinPitch];
};

module.exports = DfnPackageWithDifferentPadsData;